import React from "react";
import { fingeringToConstellationDots } from "../../lib/modoPositionConstellation";

export interface ModoPositionConstellationIconProps {
  notes: ReadonlyArray<{ string: number; fret: number }>;
  active?: boolean;
}

export const ModoPositionConstellationIcon: React.FC<ModoPositionConstellationIconProps> = ({
  notes,
  active = false,
}) => {
  const dots = fingeringToConstellationDots(notes);

  return (
    <div
      className={`relative w-6 h-5 transition-opacity ${
        active
          ? "opacity-100 text-emerald-400 drop-shadow-[0_0_5px_#34d399]"
          : "opacity-50 text-white/30 group-hover:opacity-100"
      }`}
      aria-hidden
    >
      {dots.map((d, i) => (
        <span
          key={i}
          className="absolute w-1 h-1 rounded-full bg-current"
          style={{ top: d.top, left: d.left }}
        />
      ))}
    </div>
  );
};
